import React from "react";
import {
  Navbar,
  Container,
  Nav,
  NavDropdown,
  Badge,
  Button,
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import "./ShopNavbar.css";

export default function ShopNavbar({ cartCount, user }) {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/login");
  };

  return (
    <Navbar bg="dark" variant="dark" expand="lg" sticky="top">
      <Container>
        <Navbar.Brand as={Link} to="/">
          🛍 ShopeSphere
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="shop-navbar" />
        <Navbar.Collapse id="shop-navbar">
          <Nav className="ms-auto align-items-center">
            <Nav.Link as={Link} to="/">Home</Nav.Link>

            <Nav.Link as={Link} to="/cart">
              Cart{" "}
              {cartCount > 0 && (
                <Badge bg="warning" text="dark">
                  {cartCount}
                </Badge>
              )}
            </Nav.Link>

            <Nav.Link as={Link} to="/checkout">Checkout</Nav.Link>

            {/* === Auth Links === */}
            {!user ? (
              <>
                <Nav.Link as={Link} to="/login">Login</Nav.Link>
                <Nav.Link as={Link} to="/register">Register</Nav.Link>
              </>
            ) : (
              <NavDropdown
                title={user.username || "Account"}
                id="profile-dropdown"
                align="end"
              >
                <NavDropdown.Item as={Link} to="/Account">
                  My Account
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item onClick={handleLogout}>
                  Logout
                </NavDropdown.Item>
              </NavDropdown>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
